import { Keys } from '../helpers/Keys';
import { Module } from '../Module';

interface IPreventInputAttributes extends ng.IAttributes {
  tbPreventInput: string;
}

Module.instance().directive('tbPreventInput', ['$parse', ($parse: ng.IParseService) => {
  return {
    require: '?ngModel',
    link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: IPreventInputAttributes, ngModelCtrl: ng.INgModelController) => {
      if (!ngModelCtrl) {
        return;
      }

      const preventFn = $parse(attrs.tbPreventInput);

      ngModelCtrl.$parsers.push((val: string) => {
        let lastValidValue = ngModelCtrl.$modelValue;
        if(val && preventFn(scope, { value: val })) {
          ngModelCtrl.$setViewValue(lastValidValue);
          ngModelCtrl.$render();
        } else {
          lastValidValue = val;
        }
        return lastValidValue;
      });

      //Needed to prevent added spaces before and after the input
      element.on('keypress', (event: JQuery.Event) => {
        if(event.keyCode === Keys.Space && preventFn(scope, { value: element.val()+' ' })) {
          event.preventDefault();
        }
      });
    }
  };
}]);
